module.exports = __webpack_public_path__ + "static/img/region_distribution_1.1f711ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/region_distribution_1.png
// module id = PG5k
// module chunks = 6